/* w9-collection-sidenav: mounts the rail beside the grid and groups the grid.
   Two modes, decided by the data blocks the section emits:
   - part mode (bike / ride-type pages): one section per part-* tag, ids part-<slug>
   - type mode (a part page named in type_group_collections): one section per product
     type, ids type-<slug>, plus an anchor sub-list under the active category in the rail.
   Nothing is re-rendered: the theme's own <li> cards are moved, so prices, badges and
   add-to-cart keep working untouched. */
(function () {
  var BP = 990;

  function slug(s) {
    return String(s).toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'x';
  }

  function parseMap(text) {
    var map = {};
    text.split('|').forEach(function (pair) {
      var i = pair.lastIndexOf('=');
      if (i > 0) map[pair.slice(0, i).trim()] = pair.slice(i + 1).trim();
    });
    return map;
  }

  // "Off-Road Tires, Tubes & Rim Strips=Tubes|Rim Strips" -> ordered groups, each owning one
  // or more product types. Types that are not named become their own group, alphabetically,
  // after the named ones - so a new tire type shows up without a theme edit.
  function parseOrder(spec) {
    var groups = [];
    spec.split(',').forEach(function (e) {
      e = e.trim();
      if (!e) return;
      var label = e;
      var types = [e];
      var i = e.indexOf('=');
      if (i > 0) {
        label = e.slice(0, i).trim();
        types = e.slice(i + 1).split('|').map(function (t) { return t.trim(); }).filter(Boolean);
      }
      groups.push({ label: label, slug: slug(label), types: types.map(function (t) { return t.toLowerCase(); }) });
    });
    return groups;
  }

  // The data blocks are siblings of the nav, and the nav gets re-parented into
  // .facets-wrap - so look them up on the document, not inside the panel.
  function catalog(nav) {
    var tmap = document.querySelector('[data-w9sn-tmap]');
    var tconf = document.querySelector('[data-w9sn-tconf]');
    if (tmap && tconf) {
      var conf;
      try { conf = JSON.parse(tconf.textContent); } catch (e) { return null; }
      return { mode: 'type', prefix: 'type-', map: parseMap(tmap.textContent), groups: parseOrder(conf.order || ''), other: conf.other || 'More' };
    }
    var mapEl = document.querySelector('[data-w9sn-map]');
    var ordEl = document.querySelector('[data-w9sn-order]');
    if (!mapEl || !ordEl) return null;
    var order;
    try { order = JSON.parse(ordEl.textContent); } catch (e) { return null; }
    return {
      mode: 'part',
      prefix: 'part-',
      map: parseMap(mapEl.textContent),
      groups: order.map(function (o) { return { label: o.label, slug: o.slug, types: [o.slug] }; }),
      other: (nav && nav.getAttribute('data-w9sn-other')) || 'More parts'
    };
  }

  function handleOf(li) {
    var a = li.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var h = a.getAttribute('href').split('/products/')[1];
    return h ? h.split('?')[0].split('#')[0].replace(/\/$/, '') : null;
  }

  // Returns true once there is nothing more to do (grouped, or nothing to group);
  // false means the grid has not rendered yet and the caller should retry.
  function group(nav) {
    var data = catalog(nav);
    if (!data) return true;
    var ul = document.getElementById('product-grid');
    if (!ul) return false;
    if (ul.dataset.w9snGrouped) return true;
    if (!ul.children.length) return false;

    var groups = data.groups.map(function (g) { return { label: g.label, slug: g.slug, types: g.types, items: [] }; });
    var extra = {};
    var leftovers = [];
    var banners = [];

    Array.prototype.slice.call(ul.children).forEach(function (li) {
      if (li.classList.contains('grid-item-block')) { banners.push(li); return; }
      var h = handleOf(li);
      var key = h ? data.map[h] : null;
      if (!key) { leftovers.push(li); return; }
      var k = key.toLowerCase();
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].types.indexOf(k) !== -1) { groups[i].items.push(li); return; }
      }
      if (data.mode === 'type') (extra[key] = extra[key] || []).push(li);
      else leftovers.push(li);
    });

    Object.keys(extra).sort().forEach(function (t) {
      groups.push({ label: t, slug: slug(t), types: [t.toLowerCase()], items: extra[t] });
    });

    var frag = document.createDocumentFragment();
    var rendered = [];

    function section(id, label, items) {
      if (!items || !items.length) return;
      var sec = document.createElement('section');
      sec.className = 'w9sn-group';
      if (id) sec.id = id;
      var h2 = document.createElement('h2');
      h2.className = 'w9sn-group__title';
      h2.appendChild(document.createTextNode(label));
      var n = document.createElement('span');
      n.className = 'w9sn-group__count';
      n.textContent = items.length;
      h2.appendChild(n);
      sec.appendChild(h2);
      var list = document.createElement('ul');
      list.className = ul.className;
      items.forEach(function (li) { list.appendChild(li); });
      sec.appendChild(list);
      frag.appendChild(sec);
      if (id) rendered.push({ id: id, label: label, count: items.length });
    }

    if (banners.length) {
      var bl = document.createElement('ul');
      bl.className = ul.className;
      banners.forEach(function (li) { bl.appendChild(li); });
      frag.appendChild(bl);
    }

    var used = 0;
    groups.forEach(function (g) {
      used += g.items.length;
      section(data.prefix + g.slug, g.label, g.items);
    });
    section('', data.other, leftovers);

    if (!used) { ul.dataset.w9snGrouped = '0'; return true; }
    ul.parentNode.insertBefore(frag, ul);
    ul.style.display = 'none';
    ul.dataset.w9snGrouped = '1';
    if (data.mode === 'type') subnav(nav, rendered);
    spy(nav);
    return true;
  }

  // Type mode: the groups become an anchor list under the active category in the rail.
  function subnav(nav, rendered) {
    if (!nav || !rendered.length) return;
    var cur = nav.querySelector('.w9sn__list > li > a[aria-current="page"]');
    if (!cur || nav.querySelector('[data-w9sn-subnav]')) return;
    var ul = document.createElement('ul');
    ul.className = 'w9sn__sub';
    ul.setAttribute('data-w9sn-subnav', '');
    rendered.forEach(function (g) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + g.id;
      a.appendChild(document.createTextNode(g.label));
      var n = document.createElement('span');
      n.className = 'w9sn__sub-count';
      n.textContent = g.count;
      a.appendChild(n);
      li.appendChild(a);
      ul.appendChild(li);
    });
    cur.parentNode.appendChild(ul);
  }

  function spy(nav) {
    if (!nav || !window.IntersectionObserver) return;
    var links = nav.querySelectorAll('.w9sn__list a[href^="#"]');
    if (!links.length) return;
    var byId = {};
    Array.prototype.forEach.call(links, function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        Array.prototype.forEach.call(links, function (a) { a.removeAttribute('aria-current'); });
        var a = byId[en.target.id];
        if (a) a.setAttribute('aria-current', 'page');
      });
    }, { rootMargin: '-15% 0px -70% 0px' });
    Object.keys(byId).forEach(function (id) {
      var sec = document.getElementById(id);
      if (sec) io.observe(sec);
    });
  }

  function mount(nav, sid) {
    var wrap = document.querySelector('.facets-wrap');
    if (!wrap) return false;
    if (!wrap.contains(nav)) {
      var host = nav.parentElement;
      wrap.insertBefore(nav, wrap.firstElementChild);
      wrap.classList.add('w9sn-host');
      if (host && host.id === 'shopify-section-' + sid) host.classList.add('w9sn-moved');
    }
    return true;
  }

  function fold(nav) {
    var small = window.innerWidth < BP;
    var groups = nav.querySelectorAll('details.w9sn__group');
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].dataset.w9snTouched === '1') continue;
      groups[i].open = !small;
    }
  }

  function init(nav) {
    if (!nav || nav.dataset.w9snInit === '1') return;
    nav.dataset.w9snInit = '1';
    var sid = nav.getAttribute('data-w9sn-sid');

    if (!mount(nav, sid)) {
      // The grid section may render after this one; retry briefly, then give up
      // and leave the rail where it is rather than hiding it.
      var tries = 0;
      var t = setInterval(function () { if (mount(nav, sid) || ++tries > 20) clearInterval(t); }, 100);
    }
    fold(nav);
    nav.addEventListener('click', function (e) {
      var d = e.target.closest ? e.target.closest('details.w9sn__group') : null;
      if (d) d.dataset.w9snTouched = '1';
    }, true);

    if (!group(nav)) {
      var gtries = 0;
      var gt = setInterval(function () { if (group(nav) || ++gtries > 20) clearInterval(gt); }, 100);
    }

    var sel = nav.querySelector('[data-w9sn-bike]');
    if (sel && sel.dataset.w9snWired !== '1') {
      sel.dataset.w9snWired = '1';
      sel.addEventListener('change', function () { if (this.value) window.location.href = this.value; });
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { fold(nav); }, 150);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.w9sn[data-w9sn]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();